import { render, staticRenderFns } from "./SendNoteList.vue?vue&type=template&id=2da890a2&scoped=true"
import script from "./SendNoteList.vue?vue&type=script&lang=js"
export * from "./SendNoteList.vue?vue&type=script&lang=js"
import style0 from "./SendNoteList.vue?vue&type=style&index=0&id=2da890a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da890a2",
  null
  
)

export default component.exports